import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { TEN_MINUTES_IN_MS, THIRTY_MINUTES_IN_MS } from '@/legacy/constants';
import { COMPANIES_OPTIONS } from '@/legacy/constants/queryKeys';
import { Option } from '@/legacy/types';

import { fetchCompaniesOptions } from '../service/companiesOptions';
import { markOptionsAsNonTranslatable } from '@/shared/utils/markOptionsAsNonTranslatable';

export const useCompaniesOptions = () => {
	const { data, isLoading, error } = useQuery<Option[]>({
		queryKey: [COMPANIES_OPTIONS],
		queryFn: fetchCompaniesOptions,
		staleTime: TEN_MINUTES_IN_MS,
		gcTime: THIRTY_MINUTES_IN_MS,
		refetchOnWindowFocus: false,
		retry: false,
	});

	const options = useMemo(() => markOptionsAsNonTranslatable(data ?? []), [data]);

	return { data: options, isLoading, error };
};
